import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { slideRight } from 'src/app/animations';
import { DataService } from 'src/app/_services/data.service';
import { slideUp, anim } from 'src/app/animations';


@Component({
  selector: 'app-views-from-floors-list',
  templateUrl: './views-from-floors-list.component.html',
  styleUrls: ['./views-from-floors-list.component.scss'],
  animations: [
    slideUp, anim
  ]
})
export class ViewsFromFloorsListComponent implements OnInit {
  projUid: any;
  buildList: any;
  compositeDesign: boolean = false;
  unika: boolean = false;
  floorsShow: boolean = true;

  @Input() public projId: string;
  @Input() public routeParams;
  @Output()
  public showBuildingSubMenu = new EventEmitter();

  zones: { title: string; list: any; }[];
  itemToEdit: any;
  urlSwitcher: string = '';
  currentLanguage: string = 'he';

  constructor(
    public dataService: DataService,
    private route: ActivatedRoute,
    private router: Router
  ) {
    this.projUid = this.route.snapshot.params.idp
  }

  ngOnInit(): void {
    this.urlSwitcher = this.dataService.wichDesign().urlSwitcher;
    this.compositeDesign = this.dataService.wichDesign().compositeDesign;
    this.unika = this.dataService.wichDesign().unika;
    if (this.route.snapshot.queryParams.lang) {
      this.currentLanguage = this.route.snapshot.queryParams.lang;
    }
    this.dataService.getItemsByProjId(this.projId).subscribe(buildList => {
      this.buildList = buildList;
      this.addZoneTitles(buildList)
      this.itemToEdit = this.zones[0].list[0];
    })
    // let segment;
    // if (this.route.snapshot.firstChild) {
    //   segment = this.route.snapshot.firstChild.url;
    // } else {
    //   segment = this.route.snapshot.url;
    // }
    // this.ifCompositeDesign(segment);
  }

  editItem(item) {
    // this.floorsShow = !this. floorsShow;
    this.itemToEdit = item;
  }

  addZoneTitles(buildings) {
    const areasWithBuildings = buildings.reduce((acc, building) => {
      if (!acc[building.buildingZone]) {
        acc[building.buildingZone] = [];
      }
      acc[building.buildingZone].push(building);
      return acc;
    }, {});

    const areasWithBuildingsArray = Object.keys(areasWithBuildings).map(area => ({
      title: area,
      list: areasWithBuildings[area]
    }))

    this.zones = areasWithBuildingsArray;
  }

  viewBuildDetailsMenu(building, item) {
    if (item === 'building') {
      this.showBuildingSubMenu.emit('false');
      
      if (this.routeParams) {
        this.router.navigate([this.urlSwitcher + this.routeParams.id + '/' + this.routeParams.idp + '/building/' + building.uid], {
          queryParams: { lang: this.currentLanguage },
          queryParamsHandling: 'merge' // Merges with any existing query params in the URL
        });
      }
    } else if (item === 'floor') {
      this.showBuildingSubMenu.emit('false');

      this.router.navigate([this.urlSwitcher + this.routeParams.id + '/' + this.routeParams.idp + '/viewFloors/' + building.floor.number + '/' + building.floor.panoramaView],
        {
          queryParams: { lang: this.currentLanguage }, // Add your `lang` parameter here
          skipLocationChange: false,
        }
      );
      // if (this.compositeDesign && !this.unika) {
      //   //   this.router.routeReuseStrategy.shouldReuseRoute = function () {
      //   //     return true;
      //   // };
      //   this.router.navigate(['/company/n/' + this.routeParams.id + '/' + this.routeParams.idp + '/viewFloors/' + building.floor.number + '/' + building.floor.panoramaView], { skipLocationChange: false });
      // } else if (this.compositeDesign && this.unika) {
      //   this.router.navigate(['/company/u/' + this.routeParams.id + '/' + this.routeParams.idp + '/viewFloors/' + building.floor.number + '/' + building.floor.panoramaView], { skipLocationChange: false });
      // }
      // else {
      //   this.router.navigate(['/company/' + this.routeParams.id + '/' + this.routeParams.idp + '/viewFloors/' + building.floor.number + '/' + building.floor.panoramaView]);
      // }
    }
  }
  // ifCompositeDesign(segment) {
  //   if (segment.length > 3) {
  //     for (let i = 0; segment.length > i; i++) {
  //       if (segment[i].path === 'n') {
  //         this.compositeDesign = true;
  //       } else if (segment[i].path === 'u') {
  //         this.compositeDesign = true;
  //         this.unika = true;
  //       }
  //     }
  //   }
  // }

  // openFloors(item) {
  //   // console.log("openFloors", item)
  //   this.router.navigate(['/company/' + this.routeParams.id + '/' + this.routeParams.idp + '/test/viewFloors/' + item.floor.panoramaView]);
  //   // this.closeAllSubMenus();
  //   // this.child.itemToview.floor = item;
  //   // this.child.viewFloors($event, this.child.itemToview);
  //   // this.currentItemMenu($event);
  //   // this.ifShowMenu();
  //   // this.showFloorsViewSubMenu = false;
  // }
}
